import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

interface Feedback {
  device: {
    id: string;
  };
  author: {
    id: string;
  };
  feedbackStatus: "Valid" | "Dismissed";
  feedbackTargetId: string;
  feedbackType: "collisionDetection";
  submittedOn: string;
}

export const useFeedback = (targetId: string) => {
  const { activeSessionId, geotabClient } = useGeotabClient();

  return useQuery<Feedback[]>({
    queryKey: ["feedback", activeSessionId, targetId],
    queryFn: async ({ signal }) => {
      const result = geotabClient.call("Get", {
        typeName: "Feedback",
        search: {
          feedbackTargetId: targetId,
          feedbackType: "collisionDetection",
        },
        resultsLimit: 50000,
        signal,
      }) as Promise<Feedback[]>;
      return result ?? Promise.resolve([]);
    },
  });
};
